// 财税实战课堂（学员端）· 交互原型 V0.3 迁移页面
import practicalClassLayout from "@/views/practicalClass/index.vue";

export const practicalClassRoutes = [
  {
    path: "/practicalClass",
    name: "PracticalClass",
    component: practicalClassLayout,
    hidden: true,
    redirect: "/practicalClass/wall",
    children: [
      {
        path: "wall",
        name: "PracticalClassWall",
        component: () => import("@/views/practicalClass/questionWall/index.vue"),
        meta: {
          documentTitle: "问题与投票",
        },
      },
      {
        path: "detail",
        name: "PracticalClassDetail",
        component: () =>
          import("@/views/practicalClass/questionDetail/index.vue"),
        meta: {
          documentTitle: "问题放大与回复",
        },
      },
      {
        path: "tasks",
        name: "PracticalClassTasks",
        component: () => import("@/views/practicalClass/tasks/index.vue"),
        meta: {
          documentTitle: "学习任务",
        },
      },
      {
        path: "assignment",
        name: "PracticalClassAssignment",
        component: () =>
          import("@/views/practicalClass/assignment/index.vue"),
        meta: {
          documentTitle: "实战作业",
        },
      },
      {
        path: "quiz",
        name: "PracticalClassQuiz",
        component: () => import("@/views/practicalClass/quiz/index.vue"),
        meta: {
          documentTitle: "课程测试",
        },
      },
      {
        path: "resources",
        name: "PracticalClassResources",
        component: () =>
          import("@/views/practicalClass/courseMaterials/index.vue"),
        meta: {
          documentTitle: "课程资料",
        },
      },
      {
        path: "schedules",
        name: "PracticalClassSchedules",
        component: () => import("@/views/practicalClass/schedules/index.vue"),
        meta: {
          documentTitle: "本省开课",
        },
      },
      {
        path: "scores",
        name: "PracticalClassScores",
        component: () => import("@/views/practicalClass/scores/index.vue"),
        meta: {
          documentTitle: "我的成绩",
        },
      },
      {
        // 扫码入课：隐藏布局头尾（对应原型 showPage 里 entry 隐藏 cl-head/cl-context）
        path: "entry",
        name: "PracticalClassEntry",
        component: () => import("@/views/practicalClass/entry/index.vue"),
        meta: {
          documentTitle: "扫码入课",
          hideChrome: true,
        },
      },
    ],
  },
];
